import { animateScrollToY } from "../../../shared/helpers/animate-scroll"

export default class ScrollTo {
  constructor () {
    this.selectorScrollTo = "[data-trigger-smooth-scroll]"
    this.offsetTop = -140
    this.duration = 450

    if (document.querySelector(this.selectorScrollTo)) {
      this.bindEvents()
    }
  }

  bindEvents () {
    document.querySelectorAll(this.selectorScrollTo).forEach((link) => {
      link.addEventListener("click", (event) => {
        const href = link.getAttribute("href")
        if (!href || href === "#") return

        const target = document.querySelector(href)
        if (!target) return

        event.preventDefault()
        const top = target.getBoundingClientRect().top + window.scrollY + this.offsetTop
        animateScrollToY(top, this.duration)
      })
    })
  }
}
